<template>
  
  <v-col cols="12" sm="6" md="4" lg="3">
    <slot />
  </v-col>

</template>
